<template>
    <div class="CreatePicture">
        <b-row>
            <Dropzone
				id="dropzone"
				:awss3="awss3"
				:options="dropzoneOptions"
				@vdropzone-s3-upload-error="s3UploadError"
				@vdropzone-s3-upload-success="s3UploadSuccess"
				@vdropzone-success="dropzoneSuccess"
			/>
        </b-row>
    </div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import AmplifyStore from '../store/store';
import {HTTP} from './http-common';
import axios from 'axios';
import Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        Dropzone,
    },
    name: 'CreatePicturePage',
    data () {
        return {
            url: 'default',
            images: {},
            dropzoneOptions: {
                method: 'POST',
				thumbnailWidth: 150,
            },
            awss3: {
                signingURL: (f) => {return 'https://cwxo41u99h.execute-api.eu-central-1.amazonaws.com/Prod/presign'},
                headers: {},
                params: {},
				sendFileToServer: false,
				withCredentials: false,
            },
        }
    },
    methods: {
		dropzoneSuccess (file, res) {
			// console.log("success'?")
		},
		s3UploadError (errorMessage) {
			// Show an error message on failure
			console.log(errorMessage)
		},
		s3UploadSuccess (s3ObjectLocation) {
			// Show a message after uploaded to S3?
			// console.log(s3ObjectLocation)
		},
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
    margin-top: 2em;
}
</style>




// WEBPACK FOOTER //
// src/components/CreatePicturePage.vue